export class AsyncServiceBase {
    public static instances: Array<AsyncServiceBase> = [];
    constructor() {
        AsyncServiceBase.instances.push(this);
    }

    public initializeResolve: (value: unknown) => void;
    public initializePromise = new Promise(resolve => {
        this.initializeResolve = resolve;
    });

    public static reset() {
        for (const item of AsyncServiceBase.instances) {
            item.initializePromise = new Promise(resolve => {
                item.initializeResolve = resolve;
            });
        }
    }
}
